export default function testimonialsReducer(state = [], action) {
  switch (action.type) {
    case 'SET':
      const newTestimonials = action.payload.testimonials.map((testimonial, index) => ({
        id: index,
        text: testimonial,
        owner: '',
        relationship: '',
      }));
      return newTestimonials;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/Testimonials/reducer/index.js